<div class="dialog">

  <app-header-dialog [iconName]="'supervisor_account'">
    Admins
  </app-header-dialog>
  <div class='content'>

    <form class="form" name="accountForm" [formGroup]='accountForm' autocomplete="off">

      <div class='container'>

        <div class="content-tab" class="account-login">

          <div class='account-panel'>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Nome</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="accountForm.controls.displayName"
                autocomplete="off">
              <mat-error *ngIf="accountForm.controls.displayName.hasError('required')">
                Nome é obrigatório
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>E-mail</mat-label>
              <input matInput type="email" [errorStateMatcher]="matcher" [formControl]="accountForm.controls.email"
                autocomplete="off">
              <mat-error
                *ngIf="accountForm.controls.email.hasError('email') && !accountForm.controls.email.hasError('required')">
                Email inválido
              </mat-error>
              <mat-error *ngIf="accountForm.controls.email.hasError('required')">
                Email é obrigatório
              </mat-error>
            </mat-form-field>

            <div *ngIf="!isEdit">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Senha</mat-label>
                <input matInput type="password" [errorStateMatcher]="matcher"
                  [formControl]="accountForm.controls.password" autocomplete="off">
                <mat-error *ngIf="accountForm.controls.password.hasError('required')">
                  Senha é obrigatório
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Confirma</mat-label>
                <input matInput type="password" [errorStateMatcher]="matcher"
                  [formControl]="accountForm.controls.confirm" autocomplete="off">
                <mat-error *ngIf="accountForm.controls.confirm.hasError('required')">
                  Confirmação é obrigatória
                </mat-error>
                <mat-error *ngIf="accountForm.controls.confirm.hasError('mustMatch')">
                  Senha e confirmação devem ser iguais.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="account-claims">
              <mat-checkbox class="account-claim" color='primary' [formControl]="accountForm.controls.claim_admin">
                Admin
              </mat-checkbox>
              <!--*ngIf="claims.admin"-->
              <mat-checkbox class="account-claim" color='primary' [formControl]="accountForm.controls.claim_operator">
                Operador
              </mat-checkbox>

              <mat-checkbox class="account-claim" color='primary' [formControl]="accountForm.controls.claim_user">
                Usuário
              </mat-checkbox>

            </div>

          </div>

          <div class='account-panel'>
            <div class="account-image">

              <img [src]="_accountsService.storedImage" height="200px" *ngIf="_accountsService.storedImage">
              <input #file type="file" accept='image/png, image/jpg' style='display:none;'
                (change)="_accountsService.previewImage($event)" />

              <hr>
              <button mat-raised-button (click)='file.click()'>
                <mat-icon class='icon-add'>image_search</mat-icon>
              </button>

            </div>
          </div>

        </div>

      </div>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='insert()' [disabled]="accountForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="accountForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>
</div>